import React from 'react';
import {
  Facebook, Instagram, YouTube, Link as LinkIcon, LinkedIn, X as XIcon,
} from '@mui/icons-material';
import { SvgIconProps } from '@mui/material';
import { TikTokIcon } from './TikTokIcon';
import { BehanceIcon } from './BehanceIcon';
import { TwitchIcon } from './TwitchIcon';
import { ThreadsIcon } from './ThreadsIcon';
import { SnapchatIcon } from './SnapchatIcon';

export const networkToColor = (network: number) => {
  if (network === 1) { // twitter
    return '#000000';
  } if (network === 2) { // 'instagram'
    return '#c32aa3';
  } if (network === 3) { // 'facebook'
    return '#3b5998';
  } if (network === 4) { // 'youtube'
    return '#ff0000';
  } if (network === 5) { // 'tiktok'
    return '#EE1D52';
  } if (network === 6) { // 'behance'
    return '#053eff';
  } if (network === 8) { // 'linkedin'
    return '#0077b5';
  } if (network === 9) { // 'twitch'
    return '#9146FF';
  }
  return '#393939';
};

const colorToHex = {
  light: '#6b7280',
  dark: '#393939',
  white: '#ffffff',
};

interface Props extends SvgIconProps {
  network: number;
  /** pass in 'color' to default to the designated network color  */
  iconColor?: 'color' | 'light' | 'dark' | 'white';
}

export const NetworkIcon = ({
  network, iconColor = 'dark', style, ...props
}: Props) => {
  const color = iconColor === 'color' ? networkToColor(network) : colorToHex[iconColor];
  if (network === 1) {
    return <XIcon style={{ color, ...style }} {...props} />;
  } if (network === 2) {
    return <Instagram style={{ color, ...style }} {...props} />;
  } if (network === 3) {
    return <Facebook style={{ color, ...style }} {...props} />;
  } if (network === 4) {
    return <YouTube style={{ color, ...style }} {...props} />;
  } if (network === 5) {
    return <TikTokIcon style={{ color, ...style }} {...props} />;
  } if (network === 6) {
    return <BehanceIcon style={{ color, ...style }} {...props} />;
  } if (network === 8) {
    return <LinkedIn style={{ color, ...style }} {...props} />;
  } if (network === 7) {
    return <LinkIcon style={{ color, ...style }} {...props} />;
  } if (network === 9) {
    return <TwitchIcon style={{ color, ...style }} {...props} />;
  } if (network === 10) {
    return <ThreadsIcon style={{ color, ...style }} {...props} />;
  } if (network === 11) {
    return <SnapchatIcon style={{ color, ...style }} {...props} />;
  }
  return (<div />);
};
